import { call, put, select } from 'redux-saga/effects';
import { setPinnedMessageSessions } from '../../../state/message/messageSessionSlice';
import { selectUserCredentials } from '../../../state/userCredential/userCredentialSlice';
import { getPinnedMessageSessions } from '../../../browser/storage';

export function* loadPinnedMessageSessionSaga() {
    const { uid } = yield select(selectUserCredentials);
    const persistedPinnedSessions = yield call(getPinnedMessageSessions, uid);
    yield put(setPinnedMessageSessions(persistedPinnedSessions));
  }